import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

function TabContainer({ children }) {
  return (
    <Typography component="div" style={{ padding: 24, minWidth: '634px' }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.element.isRequired,
};

export default TabContainer;
